/**
 * @generated SignedSource<<0c88cedb1bfbe9adfc9390102393775e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutReviewStep_deliveryOptions$data = ReadonlyArray<{
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutDeliveryOptions_deliveryOptions" | "CheckoutReviewStepDeliveryView_deliveryOptions" | "useDisableShippingSubmit_deliveryOptions">;
  readonly " $fragmentType": "CheckoutReviewStep_deliveryOptions";
}>;
export type CheckoutReviewStep_deliveryOptions$key = ReadonlyArray<{
  readonly " $data"?: CheckoutReviewStep_deliveryOptions$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutReviewStep_deliveryOptions">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "CheckoutReviewStep_deliveryOptions",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutReviewStepDeliveryView_deliveryOptions"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutDeliveryOptions_deliveryOptions"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useDisableShippingSubmit_deliveryOptions"
    }
  ],
  "type": "ShipmentQuote",
  "abstractKey": null
};

(node as any).hash = "dad3e371dc483dfb93123e442bc0deb5";

export default node;
